<template>
  <div class="col-lg-12 col-md-10 col-sm-9 content container-fluid">
    <div class="wrapper">
      <div class="container-all-offers container">
        <div class="carousel-component-wrap">
          <div class="left-scroller-btn" @click="leftScrolling">
            <span class="fas fa-chevron-left"></span>
          </div>
          <div class="carousel-content">
            <div>
              <div
                v-for="service in services"
                class="carousel-item"
                @click="goToService(service.id)"
              >
                <span>{{ service.name }}</span>
              </div>
            </div>
          </div>
          <div class="right-scroller-btn" @click="rightScrolling">
            <span class="fas fa-chevron-right"></span>
          </div>
        </div>
        <!-- Ofertas -->
        <div class="row section--offers" v-for="service in services">
          <div class="col-lg-12">
            <!-- Encabezado de Ofertas -->
            <div class="row offer__title">
              <div class="col-md-10">
                <h1>{{ service.name }}</h1>
              </div>
              <div class="col-md-2">
                <a href="/#!/services/{{service.id}}">Ver todos las ofertas</a>
              </div>
            </div>

            <div class="row offer__content">
              <div
                class="col-md-4 offer__cards"
                v-for="category in service.categories"
              >
                <a href="/#!/client-offers-all/{{service.id}}/{{category.id}}">
                  <h3>{{ category.name }}</h3>
                </a>
                <a href="/#!/client-offers-all/{{service.id}}/{{category.id}}">
                  <img
                    src="{{this.urlApi}}{{category.offers.images[0].path}}"
                    style="width: 203px"
                  />
                </a>
                <a href="/#!/client-offers-all/{{service.id}}/{{category.id}}"
                  >Ver más</a
                >
              </div>
            </div>
          </div>
        </div>

        <div class="row section--offers" v-show="services.length == 0">
          <div class="col-lg-12">
            <!-- Encabezado de Ofertas -->
            <div class="row offer__title">
              <div class="col-md-10">
                <h1>Próximamente ofertas</h1>
              </div>
              <div class="col-md-2"></div>
            </div>

            <div class="row offer__content">
              <div class="col-md-4 offer__cards" v-for="category in [1, 2, 3]">
                <h3>...</h3>
                <img
                  src="https://via.placeholder.com/203x300"
                  style="width: 203px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import router from "vue-router";

vue.use(router);

export default {
  name: "DashboardOffers",
  referTo: "/devices-list",
  data: () => {
    return {
      urlApi: "https://api.cashdepotint.com/",
      services: [],
      showService: [],
    };
  },
  async created() {
    this.id = this.$route.query.id;
    this.employee_id = this.$route.query.employee_id;
    if (this.id) {
      window.localStorage.setItem("user_id", this.id);
      window.localStorage.setItem("employee_id", this.employee_id);
    }
    this.getServices();
  },
  methods: {
    getServices() {
      this.$http.get(apiUrl + "/offers/dashboard").then((response) => {
        this.services = response.data;
      });
    },
    goToService(id) {
      var url = "/#!/services/" + id;
      window.location = url;
    },
    leftScrolling: function () {
      let carouselContent = document.querySelector(".carousel-content");
      carouselContent.scroll({
        left: carouselContent.scrollLeft - carouselContent.offsetWidth / 2,
        behavior: "smooth",
      });
    },
    rightScrolling: function () {
      let carouselContent = document.querySelector(".carousel-content");
      carouselContent.scroll({
        left: carouselContent.scrollLeft + carouselContent.offsetWidth / 2,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style lang="css" scoped>
img {
  max-width: 100%;
}
h1 {
  font-size: 26px;
}
a {
  color: #213f99;
}
a:hover {
  text-decoration: underline;
  color: #213f99;
}
.offer__title h1 {
  font-weight: bold;
}
.offer__title a {
  display: block;
  margin: 30px 0px 20px;
  text-align: right;
}
.offer__title .col-lg-2,
.offer__title .col-lg-10 {
  padding-left: 0px;
  padding-right: 0px;
}
.offer__cards {
  max-width: 370px;
  min-height: 450px;
  background: #fff;
  border: 1px solid #ccc;
  padding: 15px 20px;
  text-align: center;
  margin: 0 10px 20px;
}
.offer__cards h3 {
  margin-top: 20px;
}
.offer__cards p {
  font-size: 18px;
  margin-top: 30px;
  color: #42494b;
}
.offer__cards a {
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
}

.carousel-component-wrap {
  display: flex;
}

.carousel-content {
  flex: 1;
  width: calc(100% - 40px);
  overflow: auto;
}

.carousel-content > div {
  display: flex;
  font-size: 13px;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.carousel-content::-webkit-scrollbar {
  display: none;
}

.carousel-content::-webkit-scrollbar-track {
  display: none;
}

.carousel-content::-webkit-scrollbar-thumb {
  display: none;
}

.carousel-item {
  padding: 0px 30px;
  cursor: pointer;
}

.carousel-item span {
  height: 28px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.carousel-item.active span {
  border-bottom: 1.2px solid;
}

.left-scroller-btn,
.right-scroller-btn {
  cursor: pointer;
  opacity: 0.6;
  height: inherit;
  display: flex;
  align-items: center;
  width: 20px;
}

.right-scroller-btn {
  justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// dashboard-offers.vue?1471565c